import { requests } from "../config";
import { IPatchItem, IPutItem } from "./models/patchItem";
import { IPostData } from "./models/postData";
import { ITeudotSmsData } from "./models/smsData";
import { ITeudotWithDetails } from "./models/teudot";
import { ITransferTeudaPayload } from "./models/transferTeuda";
import { ICreateCertFromEntryPayload } from "./models/createCertFromEntry";

export const Certificates = {
    getCertsByDate: (date: string) => requests.get(`delivery?${date}`, 'go'),
    getCertsByKosher: (date: string, id: number) => requests.get(`delivery?${date}&supervision=${id}`, 'go'),
    setStamp: (data: any) => requests.put(`delivery/bulk_mashgiah_update`, 'go', data),
    createCert: (data: IPostData) => requests.post(`delivery/16`, 'node', data),
    createCertGo: (data: IPostData) => requests.post(`delivery`, 'go', data),

    updateDeliveryByOrderOrPallet: (data: IPutItem) => requests.put(`delivery/16`, 'node', data),
    unboundPallet: (id: number) => requests.delete(`delivery/17/${id}`, 'node'),
    /*
        @param rangeQuery: string - query string with the following format:
        DateFrom=2&DateTo=3
    */
    getTeudotDetailsByDateRange: (rangeQuery: string) => requests.get(`pallet/details_list?${rangeQuery}`, 'go'),
    
    /*
        @param rangeQuery: string - query string with the following format:
        DateFrom=2&DateTo=3&SearchString=2
    */
   getTeudotWithDetails: (dates: string): Promise<ITeudotWithDetails[]> => requests.get(`delivery/pallet_details?${dates}`, 'go'),
    getTeudotDetailsSum: (rangeQuery: string) => requests.get(`pallet/details_sum?${rangeQuery}`, 'go'),
    patchTeudotDetailsItem: (id: number, data: IPatchItem) => requests.put(`pallet/detail/${id}`, 'go', data),
    sendCertBySms: (data: ITeudotSmsData) => requests.post(`delivery/sms`, 'go', data),
    transferTeudaProducts: (data: ITransferTeudaPayload): Promise<void> =>
        requests.post('delivery/transfer_products', 'go', data),
    /** Stub: creates a certificate from entry pallet details instead of pallet numbers */
    createCertFromEntry: (data: ICreateCertFromEntryPayload): Promise<void> =>
        requests.post('delivery', 'go', data),
}